import React, { useState } from 'react';

import { Alert, Box, MenuItem, TextField, Typography } from '@mui/material';

import { DossierSkipcarPlus, messageErreur, skipcarPlusActions, useSkipcarPlusProfils } from './skipcarPlusApi';
import { pourcent } from './skipcarPlusFormat';

/**
 * Vue Dieu, sur la simulation : choisir le profil de taux du dossier pendant
 * l'appel avec l'agence (Standard, Volume…), en one shot. Le profil de
 * l'agence reste le réglage par défaut de ses futurs dossiers. Une fois le
 * dossier validé par Skipcar, les taux sont figés : on passe par la dérogation
 * du contrat.
 */
const ChoixProfilSimulation: React.FC<{
  dossier: DossierSkipcarPlus;
  valideParSkipcar: boolean;
  rafraichir: () => Promise<unknown>;
}> = ({ dossier, valideParSkipcar, rafraichir }) => {
  const { data } = useSkipcarPlusProfils();
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);
  const profils = data?.profils ?? [];
  const grille = dossier.grille.taux.map(pourcent).join(' / ');

  const choisir = async (profilId: number): Promise<void> => {
    setEnCours(true);
    setErreur(null);
    try {
      await skipcarPlusActions.appliquerProfil(dossier.dealId, profilId);
      await rafraichir();
    } catch (error) {
      setErreur(messageErreur(error));
    } finally {
      setEnCours(false);
    }
  };

  return (
    <Box mb={2}>
      {valideParSkipcar || profils.length === 0 ? (
        <Typography variant="body2">
          Profil de taux : <strong>{dossier.grille.derogation ? 'Dérogation' : (dossier.grille.profilNom ?? 'Standard')}</strong> ({grille})
          {valideParSkipcar && ' · taux figés, dérogation depuis le contrat'}
        </Typography>
      ) : (
        <TextField
          select
          size="small"
          label="Profil de taux du dossier"
          value={dossier.grille.profilId ?? ''}
          disabled={enCours}
          onChange={(e) => choisir(Number(e.target.value))}
          helperText={`${grille} par semaine · le profil de l’agence reste son réglage par défaut`}
          sx={{ minWidth: 280 }}
        >
          {profils.map((profil) => (
            <MenuItem key={profil.id} value={profil.id}>
              {profil.nom} ({profil.grille.map(pourcent).join(' / ')})
            </MenuItem>
          ))}
        </TextField>
      )}
      {erreur && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {erreur}
        </Alert>
      )}
    </Box>
  );
};

export default ChoixProfilSimulation;
